/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAssessmentFrameworkOntologySync extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAssessmentFrameworkOntologySync");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAssessmentFrameworkOntologySync.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAssessmentFrameworkOntologySync>): BackgroundJobPayloadForAssessmentFrameworkOntologySync {
        let obj = Object.assign(new BackgroundJobPayloadForAssessmentFrameworkOntologySync(), model);
        BackgroundJobPayloadForAssessmentFrameworkOntologySync.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAssessmentFrameworkOntologySync>): BackgroundJobPayloadForAssessmentFrameworkOntologySync {
        if (!model) return null;
        return BackgroundJobPayloadForAssessmentFrameworkOntologySync.newInstance(<BackgroundJobPayloadForAssessmentFrameworkOntologySync> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAssessmentFrameworkOntologySync) {
        if (!obj) return;

        models.BackgroundJobPayloadForAssessmentFrameworkOntologySync.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAssessmentFrameworkOntologySync): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAssessmentFrameworkOntologySync.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
